export default "__VITE_ASSET__22558944__"